<template>
  <div class="registration scrollable-div">
    <div class="container-fluid">
      <div class="row content">
        <div class="col align-self-center">
          <Logo/>
          <div class="d-flex flex-column justify-content-center text-center header">
            <h2 class="mt-5">{{ $t('registration.reset_password_h2') }}</h2>
          </div>
          <div class="row main">
            <div class="form-group merged w-100 step-1" v-if="stepCounter === 1" :class="{ 'invalid':
                        (phone !== '' && $v.phone.$invalid)  }">

              <label class="font-weight-bold">
                {{ $t('registration.phone') }}
              </label>

              <phone-input id="phone" v-model="phone" @input="resetErrors"></phone-input>

              <button type="button" @click="begin()" :disabled="$v.phone.$invalid || loading || phone_number_not_found"
                      class="btn btn-primary mt-5">
                {{ $t('registration.next') }}
              </button>

              <div v-if="phone_number_not_found" class="alert alert-info w-100" role="alert">
                {{ $t('registration.not_support_phone') }}
              </div>
              <div v-if="too_many_attempts" class="alert alert-info w-100" role="alert">
                {{ $t('registration.try_again_leter') }}
              </div>

            </div>
            <div class="form-group merged w-100 step-2" v-if="stepCounter === 2">
              <label class="font-weight-bold text-center w-100" style="font-size: 24px;">
                {{ $t('registration.code_sms') }}
              </label>
              <PinCodeInput
                  class="d-flex justify-content-center"
                  :class="{ 'invalid': sms.code !== '' && $v.sms.code.$invalid }"
                  v-model="sms.code"
                  placeholder="0"
              />
              <div class="text-center mt-2">
                <a href="#" @click.prevent="sendSms"
                   :class='{disabled: (timer.seconds != 0)}'>{{ $t('registration.resend_sms') }}</a>
                <a href="#" class="disabled" v-if="timer.seconds!==0"> ({{ timer.seconds }})</a>
              </div>

              <button type="button" @click="nextStep()" :disabled="$v.sms.code.$invalid || loading"
                      class="btn btn-primary">
                {{ $t('registration.accept') }}
              </button>
              <div v-if="errors.sms_not_valid" class="alert alert-info w-100" role="alert">
                {{ $t('registration.invalide_sms') }}
              </div>
              <div v-if="errors.phone_already_exist" class="alert alert-info w-100" role="alert">
                {{ $t('registration.number_already_exist') }}
              </div>
            </div>
          </div>
          <vue-recaptcha
              ref="recaptcha"
              size="invisible"
              :sitekey="sitekey"
              @verify="setRecaptchaToken"
              @expired="onCaptchaExpired"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { minLength, sameAs, required, email } from 'vuelidate/lib/validators';
import Logo from '../components/Logo';
import PhoneInput from '../components/PhoneInput';
import PinCodeInput from 'vue-pincode-input';
import errors from '../store/modules/errors';
import { VueRecaptcha } from 'vue-recaptcha';

export default {
  name: 'forgot-password',
  data() {
    return {
      stepCounter: 1,
      phone: '',
      sms: {
        code: '',
        token: '',
      },
      timer: {
        seconds: 0,
        interval: null,
      },
      tokenReCaptcha: '',
      sitekey: process.env.VUE_APP_RECAPTCHA_TOKEN,
      loading: false,
      phone_number_not_found: false,
      too_many_attempts: false,
      password: null,
      password_confirmed: null,
      errors: {
        email_already_exists: false,
        sms_not_valid: false,
        phone_already_exist: false,
      },
    }
  },
  validations() {
    return {
      phone: {
        required,
        minLength: minLength(17),
      },
      password: {
        required,
        minLength: minLength(8),
      },
      password_confirmed: {
        required,
        sameAsPassword: sameAs('password'),
      },
      sms: {
        code: {
          required
        }
      },
    };
  },
  methods: {
    begin() {
      this.loading = true;
      this.$refs.recaptcha.execute();
    },
    setRecaptchaToken(recaptchaToken) {
      this.loading = false;
      this.tokenReCaptcha = recaptchaToken;
      this.nextStep();
    },
    sendSms() {
      this.setAccessibilityResendSMS();
      let sender = this.$store.dispatch('sendSms', {
        phone: this.phone,
        type: 'reset_password',
        tokenReCaptcha: this.tokenReCaptcha
      });
      sender.then(response => {
        this.stepCounter = 2;
        this.sms.token = response.sms_token
      }).catch(error => {
        if (error.response.data.code === 'too-many-attempts-exception') {
          this.too_many_attempts = true;
        }
        if (error.response.data.code === 'user-not-found-exception') {
          this.phone_number_not_found = true;
        }
        this.messageBox = error.response.data.errors;
      }).finally(() => {
        this.loading = false;
      })
    },
    nextStep() {
      let step = this.stepCounter;
      switch (step) {
        case 1:
          this.loading = true;
          this.sendSms();
          break;
        case 2:
          this.loading = true;
          this.$store.dispatch('forgotPassword', {
            login: this.phone,
            sms_code: this.sms.code,
            sms_token: this.sms.token
          }).then(({token, email}) => {
            if (token === false) {
              this.$router.push({name: 'registration.success', params: {type: 'email'}, query: {email}})
            } else {
              this.$router.push({name: 'password.reset', params: {token: token}})
            }
          }).catch(error => {
            if (error.response.data.code === 'sms-not-exists-exception') {
              this.errors.sms_not_valid = true;
            }
            if (error.response.data.code === 'unable-to-send-email-exception') {
              this.$router.push({
                name: 'error-page', params: {
                  errorText: this.$t('errors.unable_to_send_email', {email: error.response.data.context.email})
                }
              })
            }
          }).finally(() => {
            this.loading = false;
          })
          break;
      }
    },
    resetErrors() {
      this.phone_number_not_found = false
      this.too_many_attempts = false
    },
    onCaptchaExpired() {
      this.$refs.recaptcha.reset()
    },
    setAccessibilityResendSMS() {
      this.timer.seconds = process.env.VUE_APP_WAIT_TIMER;
      this.clearTimerInterval();
      this.timer.interval = setInterval(() => {
        this.timer.seconds--;
        if (this.timer.seconds == 0) {
          this.clearTimerInterval();
        }
      }, 1000);
    },
    clearTimerInterval() {
      if (this.timer.interval !== null) {
        clearInterval(this.timer.interval);
        this.timer.interval = null;
      }
    }
  },
  components: {
    Logo,
    PhoneInput,
    PinCodeInput,
    VueRecaptcha,
  },
  beforeMount() {
    this.$i18n.locale = 'ua';
  },
  beforeDestroy() {
    this.clearTimerInterval();
  },
}
</script>
